export default __webpack_public_path__ + "static/media/Pot3.bcd8eb6a.svg";